import Header from 'components/Headers/Header';
import { api } from 'Interceptor';
import React, { useEffect, useState } from 'react';
import { Button, Card, Container, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { CardHeader, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { OPEN_MODAL } from 'Store/Actions/Modal/Action';
import CreateCategoryModal from '../../components/Modal.js/CreateCategoryModal'
import { toastMessage } from 'Helper/Toaster';
import  Userpic  from "../../assets/user.png";

const Bookings = () => {
  const [category, setCategory] = useState([])
  const dispatch = useDispatch()
  const { modalReducer } = useSelector(state => state)
  async function getData() {
    const { data: { bookings } } = await api.headers().method('get', '/bookings')
    bookings.map((cat, id) => {
      cat['s.no'] = id + 1
      
      cat.full_name = `${cat.first_name + " " + cat.last_name}`
      cat.fees = `${cat.fees + " USD"}`
      cat['Email'] = <a href={`mailto:${cat.email}`} >{cat.email}</a>
      cat['phone'] = <a href={`tel:${cat.phone_number}`} >{cat.phone_number}</a>
      cat.profile_picture = <div><img src={cat.talent?.profile_picture || Userpic} className="talent_image" onError={({ currentTarget }) => (currentTarget.src = Userpic)} /> {cat.talent?.first_name} &nbsp;{cat.talent?.last_name} </div>
      cat['actions'] = <UncontrolledDropdown>
        <DropdownToggle
          className="btn-icon-only text-light"
          href="#pablo"
          role="button"
          size="sm"
          color=""
          onClick={(e) => e.preventDefault()}
        >
          <i className="fas fa-ellipsis-v" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-arrow" right>
          <DropdownItem onClick={() => dispatch(OPEN_MODAL({ isOpen: true, typeOfmodal: 'edit-category', id: cat._id, data: cat }))}>View Bookings</DropdownItem>
          <DropdownItem className="bg-translucent-danger text-white" onClick={() => dispatch(OPEN_MODAL({ isOpen: true, id: cat._id, typeOfmodal: 'delete-bookings' }))}>Delete Booking</DropdownItem>
            
        </DropdownMenu>
      </UncontrolledDropdown>
      return cat
    })
    setCategory(bookings)
  }
  useEffect(() => {
    getData()
  }, [modalReducer]);
  const columns = [
    {
      dataField: 'full_name',
      text: 'Full Name',
    },
    {
      dataField: 'Email',
      text: 'Email',
    },
    {
      dataField: 'fees',
      text: 'Price',
    },
    {
      dataField: 'phone',
      text: 'Phone',
    },
    {
      dataField: 'profile_picture',
      text: 'Talent',
    },
    {
      dataField: 'actions',
      text: 'Actions',
    },
    

  ]
  return <>
    <div>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <div className="col">
            <Card className="bg-default shadow ">
              <CardHeader className="bg-transparent border-0 d-flex justify-content-between flex-wrap-reverse align-items-center">
                <h3 className="text-white mb-0">Bookings</h3>
                
              </CardHeader>
              <BootstrapTable bordered={false} headerClasses='thead-dark' bodyClasses='text-light' wrapperClasses="table-responsive table-dark" keyField="id" data={category} columns={columns} 
              noDataIndication='No Bookings Found'
              />

            </Card>
          </div>
        </Row>
      </Container>
    </div>
    <CreateCategoryModal />
  </>
    ;
};

export default Bookings;
